import { ServiceLanguage } from "@albertine/i18n";
import { z } from "zod";

const QuickActionMessageTemplateName = z.enum([
    "agent_book_onboarding_call",
    "member_book_onboarding_call",
    "agent_onboarding_place_request",
    "member_onboarding_place_request",
]);

const InitialMessageTemplateName = z.enum([
    "agent_initial_message",
    "member_initial_message",
]);

const ServiceLanguageTemplateName = z.enum([
    "agent_service_language_changed_by_member",
]);

export const InitialMessageTemplateTemplateData = z.object({
    [InitialMessageTemplateName.enum.agent_initial_message]: z.object({
        memberInitialMessage: z.string(),
        memberInitialMessageHtml: z.string(),
    }),
    [InitialMessageTemplateName.enum.member_initial_message]: z.object({
        memberGreeting: z.string(),
        agentName: z.string(),
        trialLengthInDays: z.number().optional().nullable(),
        hasUpcomingPlans: z.boolean(),
        onboardingCallReservationUrl: z.url(),
    }),
});

export type InitialMessageTemplateTemplateData = z.infer<
    typeof InitialMessageTemplateTemplateData
>;

const MessageTemplateName = z.enum([
    "agent_first_login_after_external_onboarding",
    "agent_first_login_from_member",
    "agent_onboarding_completed_manually",
    "member_first_login_notification",
    ...InitialMessageTemplateName.options,
    ...QuickActionMessageTemplateName.options,
    ...ServiceLanguageTemplateName.options,
]);

// Partial of Message
export const MessageTemplate = z.object({
    message: z.string(),
    messageHtml: z.string(),
});

export const MessageTemplatesDoc = z.partialRecord(ServiceLanguage, MessageTemplate);

export type MessageTemplateName = z.infer<typeof MessageTemplateName>;
export type MessageTemplate = z.infer<typeof MessageTemplate>;
export type MessageTemplatesDoc = z.infer<typeof MessageTemplatesDoc>;
